/**
 * ENFAMI — menu mobile : search + devises USD/CAD/EUR + langues
 * Switch devise : 1 clic, anti multi-submit, feedback immédiat.
 */
(function () {
  'use strict';

  var switching = false;

  function getLocalizationForm() {
    return (
      document.querySelector('.drawer-localization .localization-form') ||
      document.querySelector('.menu-drawer__localization .localization-form') ||
      document.querySelector('localization-form-component form.localization-form') ||
      document.getElementById('LocalizationForm')
    );
  }

  function ensureOverlay() {
    var el = document.getElementById('ef-currency-loading');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'ef-currency-loading';
    el.className = 'ef-currency-loading';
    el.setAttribute('hidden', '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="ef-currency-loading__card">' +
      '<div class="ef-currency-loading__spinner" aria-hidden="true"></div>' +
      '<p class="ef-currency-loading__text">Mise à jour des prix…</p>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  function showCurrencyLoading(iso) {
    var el = ensureOverlay();
    var label = 'Mise à jour des prix…';
    if (iso === 'US') label = 'Passage en USD…';
    else if (iso === 'CA') label = 'Passage en CAD…';
    else if (iso === 'FR' || iso === 'DE' || iso === 'ES' || iso === 'IT' || iso === 'BE' || iso === 'NL') {
      label = 'Passage en EUR…';
    }
    var text = el.querySelector('.ef-currency-loading__text');
    if (text) text.textContent = label;
    el.removeAttribute('hidden');
    document.body.classList.add('ef-currency-switching');
  }

  function lockChips(activeIso) {
    document.querySelectorAll('[data-ef-set-country]').forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      if (activeIso && btn.getAttribute('data-ef-set-country') === activeIso) {
        btn.classList.add('is-loading');
      }
    });
  }

  function submitForm(form) {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  function setCountry(iso) {
    if (!iso || switching) return;
    switching = true;
    showCurrencyLoading(iso);
    lockChips(iso);

    try {
      if (iso === 'US') localStorage.setItem('enfami_currency_pref', 'USD');
      else if (iso === 'CA') localStorage.setItem('enfami_currency_pref', 'CAD');
      else localStorage.setItem('enfami_currency_pref', iso);
    } catch (e) {}

    var form = getLocalizationForm();
    if (!form) {
      var url = new URL(window.location.href);
      url.searchParams.set('country', iso);
      window.location.replace(url.toString());
      return;
    }

    var countryInput = form.querySelector('[name="country_code"]');
    if (!countryInput) {
      countryInput = document.createElement('input');
      countryInput.type = 'hidden';
      countryInput.name = 'country_code';
      form.appendChild(countryInput);
    }
    countryInput.value = iso;

    /* Laisse peindre l’overlay avant le submit (sinon flash blanc sans feedback) */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        submitForm(form);
      });
    });
  }

  function setLanguage(iso) {
    if (!iso || switching) return;
    var form = getLocalizationForm();
    if (!form) {
      window.location.href = window.location.pathname + '?locale=' + encodeURIComponent(iso);
      return;
    }
    var langSelect = form.querySelector('[name="language_code"]');
    if (langSelect) {
      langSelect.value = iso;
    } else {
      var hidden = form.querySelector('input[name="language_code"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'language_code';
        form.appendChild(hidden);
      }
      hidden.value = iso;
    }
    submitForm(form);
  }

  function openSearchModal() {
    var host = document.getElementById('search-modal');
    if (host && typeof host.showDialog === 'function') {
      host.showDialog();
      return;
    }
    var dialog = document.querySelector('#search-modal dialog');
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
      var input = dialog.querySelector('input[type="search"], .search-input');
      if (input) setTimeout(function () { input.focus(); }, 50);
      return;
    }
    window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/') + 'search';
  }

  document.addEventListener('click', function (e) {
    var countryBtn = e.target.closest('[data-ef-set-country]');
    if (countryBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (countryBtn.disabled || switching) return;
      var iso = countryBtn.getAttribute('data-ef-set-country');
      if (countryBtn.classList.contains('is-active')) return;
      setCountry(iso);
      return;
    }

    var langBtn = e.target.closest('[data-ef-set-language]');
    if (langBtn) {
      e.preventDefault();
      e.stopPropagation();
      setLanguage(langBtn.getAttribute('data-ef-set-language'));
      return;
    }

    var searchBtn = e.target.closest('[data-ef-mobile-search] .ef-mobile-search__btn, [data-ef-open-search]');
    if (searchBtn) {
      e.preventDefault();
      openSearchModal();
    }
  }, true);
})();
